import React, { Component } from 'react';
import { Link } from 'dva/router';
import styles from './index.less';

export default class App extends Component {
  render() {
    return (
      <section className={styles.notFoundContentWarpper}>
        <div className={styles.content}>
          <h1 className={styles.title}>404</h1>
          <p className={styles.description}>SORRY,THAT PAGE DOESN’T EXIST OR IS UNAVAILABLE.</p>
          <Link to="/">返回首页</Link>
        </div>
      </section>
    );
  }
}
